import styled from "styled-components"
import Colors from "utils/Colors"

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 0.75rem;
  border: none;
  color: ${Colors.white};
  background-color: ${Colors.loginPrimaryColor};
  border-radius: 2px;
  font-weight: 600;
  
  & span.label{
    text-transform: capitalize;
    cursor: pointer;
  }
  
  &.selected{
    color: ${Colors.accentColor};
    background-color: ${Colors.loginDarkenPrimaryColor};
    font-weight: 700;
    cursor: default;
  }
`
